import { FsApiService } from '@/app/services/auth/fs-api.service';
import { FavoritesService } from '@/app/services/favorite';
import { computed, inject, Injectable, signal } from '@angular/core';
import { catchError, map, of } from 'rxjs';
import { MatchApi } from '../../home/models';
import {
  ICompetitionMatchesApi,
  IPaginationCompetitionMatches,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class CompetitionMatchesPastService {
  private fsApi = inject(FsApiService);
  private favoritesService = inject(FavoritesService);

  isLoadingCompetitionsMatchPastFavorites = signal<boolean>(false);
  isErrorCompetitionsMatchPastFavorites = signal<boolean>(false);
  competitionsMatchPagination = signal<IPaginationCompetitionMatches | null>(
    null
  );
  competitionsMatchPast = signal<MatchApi[] | null>(null);

  paginationMatches = signal<number>(0);
  totoalPageMatches = signal<number>(1);

  isMoreMatches = computed(
    () => this.paginationMatches() < this.totoalPageMatches()
  );

  constructor() {}

  getCompetitionMatchesPast(competitionId: string, page: number = 1) {
    this.isLoadingCompetitionsMatchPastFavorites.set(true);
    if (page == 1) this.competitionsMatchPast.set([]);

    this.fsApi
      .get<ICompetitionMatchesApi>(
        `/competitions/${competitionId}/matches/past`,
        {
          params: { page, size: 10 },
        }
      )
      .pipe(
        map((data) => {
          const { Matches } = data as ICompetitionMatchesApi;

          return {
            ...data,
            Matches:
              Matches === null
                ? []
                : Matches.map((item) => {
                    this.favoritesService.checkFavoriteMatch(
                      item.Id,
                      item.IsFavorite
                    );
                    return item;
                  }),
          };
        }),
        catchError((err) => {
          console.error(err);
          this.isErrorCompetitionsMatchPastFavorites.set(true);
          this.isLoadingCompetitionsMatchPastFavorites.set(false);
          return of(null);
        })
      )
      .subscribe((data) => {
        if (!data) {
          this.isLoadingCompetitionsMatchPastFavorites.set(false);

          // this.competitionsMatchPast.set(null);
          return;
        }
        const { Matches, ...rest } = data as ICompetitionMatchesApi;

        if (Matches !== null) {
          this.competitionsMatchPast.update((prev) => [...prev!, ...Matches]);
        } else {
          this.competitionsMatchPast.set([]);
        }

        this.paginationMatches.set(rest.Page);
        this.totoalPageMatches.set(rest.NumPages);

        this.competitionsMatchPagination.set({ ...rest });
        this.isLoadingCompetitionsMatchPastFavorites.set(false);
      });
  }
}
